import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@cibli/shared';
import { useTranslation } from 'react-i18next';
type CancelModalProps = {
  onConfirm: () => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

const CancelModal = ({ onConfirm, open, onOpenChange }: CancelModalProps) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:min-w-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-2xl font-bold">
            {t('CancelModal.title')}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-lg">
            {t('CancelModal.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" size="lg" onClick={() => onOpenChange(false)}>
            {t('common.cancel')}
          </Button>
          <Button
            variant="destructive"
            size="lg"
            onClick={() => {
              onOpenChange(false);
              void onConfirm();
            }}
          >
            {t('common.confirm')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default CancelModal;
